"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomepageScreen = void 0;
const summithill_models_1 = require("@clearsummit/summithill-models");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("@/constants");
const selectors_1 = __importDefault(require("@/selectors"));
const HomepageScreen = ({ user }) => {
    if (user) {
        if (user.group === summithill_models_1.GroupType.ADMIN) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: constants_1.Routes.ManageAccounts });
        }
        if (user.group === summithill_models_1.GroupType.CAREGIVER) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: constants_1.Routes.PatientProgress });
        }
        if (user.group === summithill_models_1.GroupType.PATIENT) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: constants_1.Routes.Program });
        }
    }
    return react_1.default.createElement(react_router_dom_1.Redirect, { to: constants_1.Routes.Program });
};
exports.HomepageScreen = HomepageScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
});
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps)(exports.HomepageScreen));
